import React from "react";
import {
  PRIORITY_STYLES,
  CATEGORY_STYLES,
  assigneesLabel,
  formatDate,
  formatDateTime,
  isOverdue,
} from "../../utils/taskHelpers";

const TaskListView = ({ tasks, onOpenTask, isLoading }) => {
  if (isLoading) {
    return (
      <div className="space-y-3 p-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-14 animate-pulse rounded-lg bg-gray-100" />
        ))}
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <div className="py-16 text-center text-gray-500">
        <p className="text-lg font-medium">No tasks found</p>
        <p className="mt-1 text-sm">Try adjusting your filters or create a new task</p>
      </div>
    );
  }

  return (
    <>
      <div className="space-y-3 p-4 md:hidden">
        {tasks.map((task) => {
          const priorityClass = PRIORITY_STYLES[task.Priority] || PRIORITY_STYLES.Medium;
          const overdue = isOverdue(task.DueDate, task.expand?.Status);
          return (
            <button
              key={task.id}
              type="button"
              onClick={() => onOpenTask(task)}
              className="w-full rounded-xl border border-gray-200 bg-white p-4 text-left shadow-sm transition hover:border-[#90c740]"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-semibold text-gray-900">{task.Title}</h3>
                <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${priorityClass}`}>
                  {task.Priority}
                </span>
              </div>
              <div className="mt-3 space-y-1 text-sm text-gray-600">
                <p>
                  <span className="font-medium text-gray-800">Category:</span>{" "}
                  {task.Category || "—"}
                </p>
                <p>
                  <span className="font-medium text-gray-800">Status:</span>{" "}
                  {task.expand?.Status?.Name || "—"}
                </p>
                <p>
                  <span className="font-medium text-gray-800">Assignees:</span>{" "}
                  {assigneesLabel(task)}
                </p>
                <p className={overdue ? "font-medium text-red-600" : ""}>
                  <span className="font-medium text-gray-800">Due:</span> {formatDate(task.DueDate)}
                </p>
              </div>
            </button>
          );
        })}
      </div>

      <div className="hidden overflow-x-auto md:block">
        <table className="min-w-[900px] w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Title</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Category</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Status</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Priority</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Assignee</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Due Date</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Updated</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => {
              const priorityClass = PRIORITY_STYLES[task.Priority] || PRIORITY_STYLES.Medium;
              const overdue = isOverdue(task.DueDate, task.expand?.Status);
              return (
                <tr
                  key={task.id}
                  onClick={() => onOpenTask(task)}
                  className="cursor-pointer border-b transition hover:bg-gray-50"
                >
                  <td className="px-6 py-4">
                    <div className="font-medium text-gray-900">{task.Title}</div>
                    {task.IsArchived && (
                      <span className="mt-1 inline-block rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
                        Archived
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    {task.Category ? (
                      <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${CATEGORY_STYLES[task.Category] || "bg-gray-100 text-gray-700"}`}>
                        {task.Category}
                      </span>
                    ) : (
                      <span className="text-gray-400">—</span>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
                      style={{
                        backgroundColor: `${task.expand?.Status?.Color || "#94a3b8"}20`,
                        color: task.expand?.Status?.Color || "#64748b",
                      }}
                    >
                      {task.expand?.Status?.Name || "—"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${priorityClass}`}>
                      {task.Priority}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700">{assigneesLabel(task)}</td>
                  <td className={`px-6 py-4 ${overdue ? "font-medium text-red-600" : "text-gray-700"}`}>
                    {formatDate(task.DueDate)}
                  </td>
                  <td className="px-6 py-4 text-gray-500">{formatDateTime(task.updated)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TaskListView;
